import i18n from 'i18n';
import {
  Icon5GSignal,
  Icon4GSignal,
  IconIntercepts,
  IconAccessFunction,
  IconAlarm,
  IconReport,
  IconTenant,
} from 'utils/icons';
import _ from 'lodash';
import { NavbarItem, NavbarSubItem } from './types';
import {
  AF_ROUTE,
  CF_ROUTE,
  DISTRIBUTORS_ROUTE,
  IRI_BUFFERING_ROUTE,
  SYSTEM_CONFIGURATION_ROUTE,
  SECURITY_GATEWAY_ROUTE,
  CF_GROUP_ROUTE,
  CSP_CONFIG_ROUTE,
  TENANT_ROUTE,
  DIALED_DIGIT_EXTRACTION_SERVER_ROUTE,
  UTIMACO_PACKET_SWITCH_ROUTE,
  TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION,
  NETWORK_ID_ROUTE,
  PROCESS_OPTIONS_ROUTE,
  NETWORK,
  TARGET_TEMPLATE,
  MISCELLANEOUS,
  SYSTEM,
  XDP,
  TARGET_DOMAIN,
  PERIODIC_AUDIT_ROUTE,
  SIP_SETTING,
  FQDN,
  XTP,
  XTP_XDP_CONNECTION,
  RADIUS_PARSER_PASSWORD,
  SNMP_DEST,
  SNMP_USERS,
  EWARRANT_ROUTE
} from '../../constants';

export const externalDashboardRoute = '/external/dashboard';
export const externalSystemHealthRoute = '/external/systemhealth';
export const externalAggLicensesRoute = '/external/monitoring/agglicenses';
export const externalXcipioLicensesRoute = '/external/monitoring/xcipiolicenses';

export default function navbarConfig(
  isExternalDashboardEnabled: boolean,
  isSecurityGatewayEnabled: boolean,
  isXmsMenusEnabled = true,
  isNetworkTopologyEnabled: boolean,
  isAlarmFeatureEnabled: boolean,
  isAlarmNotificationProfileEnabled: boolean,
  externalDashboardId?: string,
  systemHealthDashboardId?: string,
  aggLicensesDashboardId?: string,
  xcipioLicensesDashboardId?: string,
  openSearchUrl?: string,
  userId?: string,
  isEWarrantEnabled = false,
  isMultitenantEnabled = false,
): NavbarItem[] {
  const navbar: NavbarItem[] = [
    {
      id: 'intercepts',
      icon: IconIntercepts(),
      text: i18n.t('common.menu.intercepts'),
      route: '/warrants',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['warrant_view', 'contacts_view'],
      children: [
        {
          id: 'warrants',
          icon: 'intersection',
          text: i18n.t('common.menu.warrants'),
          route: '/warrants',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['warrant_view'],
          isTopMenu: true,
        },
        {
          id: 'cases',
          icon: 'label',
          text: i18n.t('common.menu.cases'),
          route: '/cases',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['warrant_view', 'contacts_view'],
          isTopMenu: true,
        },
        {
          id: 'wiretaps',
          icon: IconIntercepts(),
          text: i18n.t('common.menu.wiretaps'),
          route: '/wiretaps',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['warrant_view', 'contacts_view'],
          isTopMenu: true,
        },
      ],
    },
    {
      id: 'accessFunction',
      icon: IconAccessFunction(),
      text: i18n.t('common.menu.accessFunction'),
      route: AF_ROUTE,
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['af_write'],
      children: [
        {
          id: 'afs',
          icon: Icon5GSignal(),
          text: i18n.t('common.menu.4g5gAccessFunction'),
          route: AF_ROUTE,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['af_write'],
          isTopMenu: true,
        },
        {
          id: 'xms_af',
          icon: Icon4GSignal(),
          text: i18n.t('common.menu.3gAccessFunction'),
          route: `${AF_ROUTE}/xms`,
          url: '/#!af',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['af_write'],
          isTopMenu: true,
        },
      ],
    },
    {
      id: 'cfs',
      icon: 'badge',
      text: i18n.t('common.menu.collectionFunction'),
      route: `${CF_ROUTE}`,
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['cf_write'],
    },
    {
      id: 'eWarrants',
      icon: 'endorsed',
      text: i18n.t('common.menu.eWarrants'),
      route: EWARRANT_ROUTE,
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['ewarrant_view'],
    },
    {
      id: 'xms_reports',
      icon: IconReport(),
      text: i18n.t('common.menu.reports'),
      route: '/xms/reports',
      url: '/#!reports',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['af_report', 'cf_report', 'warrant_report', 'stat_report'],
    },
    {
      id: 'xms_monitoring',
      icon: 'dashboard',
      text: i18n.t('common.menu.monitoring'),
      route: '/xms/monitoring',
      url: '/#!monitoring',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['dashboard_access'],
    },
    {
      id: 'xms_system_health',
      icon: 'pulse',
      text: i18n.t('common.menu.systemHealth'),
      route: '/xms/systemhealth',
      url: '/#!systemHealth',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['sh_access'],
    },
    {
      id: 'xms_alarm',
      icon: IconAlarm(),
      text: i18n.t('common.menu.alarm'),
      route: '/xms/alarm',
      url: '/#!alarm',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['alarm_access'],
    },
    {
      id: 'people',
      icon: 'people',
      text: i18n.t('common.menu.people'),
      route: '/users',
      openFirstChild: true,
      className: 'bp3-minimal',
      permissions: [
        'user_view',
        'userrole_view',
        'team_view',
        'policy_view',
        'audit_view',
        'contacts_view',
        'security_policy_view',
        'csp_admin',
      ],
      children: [
        {
          id: 'tenant',
          icon: IconTenant(),
          text: i18n.t('common.menu.tenant'),
          route: TENANT_ROUTE,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['csp_admin'],
          isTopMenu: true,
        },
        {
          id: 'users',
          icon: 'people',
          text: i18n.t('common.menu.users'),
          route: '/users',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['user_view'],
          isTopMenu: true,
        },
        {
          id: 'teams',
          icon: 'history',
          text: i18n.t('common.menu.teams'),
          route: '/teams',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['team_view'],
          isTopMenu: true,
        },
        {
          id: 'roles',
          icon: 'tag',
          text: i18n.t('common.menu.roles'),
          route: '/roles',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['userrole_view'],
          isTopMenu: true,
        },
        {
          id: 'securityPolicy',
          icon: 'cog',
          text: i18n.t('common.menu.securityPolicy'),
          route: '/security-policy',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['security_policy_view'],
          isTopMenu: true,
        },
      ],
    },
    {
      id: 'audit',
      icon: 'th-list',
      text: i18n.t('common.menu.audit'),
      route: '/userAudit',
      className: 'bp3-minimal',
      permissions: ['audit_log_view', 'audit_log_delete'],
      children: [
        {
          id: 'userAudit',
          icon: 'highlight',
          text: i18n.t('common.menu.userAudit'),
          route: '/userAudit',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['audit_log_view'],
          isTopMenu: true,
        },
        // {
        //   id: 'general',
        //   icon: 'search-around',
        //   text: i18n.t('common.menu.generalAudit'),
        //   route: '/audit',
        //   className: 'bp3-intent-primary',
        //   inactiveClassName: 'bp3-minimal',
        //   permissions: ['audit_log_view'],
        //   isTopMenu: true,
        // },
      ],
    },
    {
      id: 'systemConfiguration',
      icon: 'settings',
      text: i18n.t('common.menu.settings'),
      route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}`,
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: [
        'br_access',
        'dfsubsys_access',
        'mml_access',
        'wt_access',
        'dc_access',
        'tp_access',
        'cf_write',
      ],
      children: [
        {
          id: 'xms_system_conf',
          text: i18n.t('common.menu.systemConfiguration'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}`,
          url: '/#!sysconfhome',
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: [
            'br_access',
            'dfsubsys_access',
            'mml_access',
            'wt_access',
          ],
          isTopMenu: true,
        },
        {
          id: 'ss8_distributors',
          icon: 'search-around',
          text: i18n.t('common.menu.distributors'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DISTRIBUTORS_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'cf_groups',
          icon: 'office',
          text: i18n.t('common.menu.collectionFunctionGroups'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CF_GROUP_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['cf_write'],
        },
        {
          id: 'csp_configs',
          icon: 'globe-network',
          text: i18n.t('common.menu.cspConfigs'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${CSP_CONFIG_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['csp_admin'],
        },
        {
          id: 'dipms',
          icon: 'numerical',
          text: i18n.t('common.menu.ddeServers'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${DIALED_DIGIT_EXTRACTION_SERVER_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        // {
        //   id: 'iri_buffering',
        //   icon: 'numerical',
        //   text: i18n.t('common.menu.iriBuffering'),
        //   route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${IRI_BUFFERING_ROUTE}`,
        //   className: 'bp3-intent-primary',
        //   inactiveClassName: 'bp3-minimal',
        //   permissions: ['dc_access'],
        // },
        {
          id: 'process_options',
          icon: 'numerical',
          text: i18n.t('common.menu.ddeServers'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PROCESS_OPTIONS_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'sipSetting',
          icon: 'numerical',
          text: i18n.t('common.menu.sipSetting'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${SIP_SETTING}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          hideTitle: true,
          permissions: [
            'br_access',
            'dfsubsys_access',
            'mml_access',
            'wt_access',
          ],
        },
        {
          id: 'periodic_audit',
          icon: 'numerical',
          text: i18n.t('common.menu.ddeServers'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${PERIODIC_AUDIT_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'utmpktcfcis',
          icon: 'numerical',
          text: i18n.t('common.menu.utimacoPacketSwitch'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_PACKET_SWITCH_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'targetDeliveryTemplatePerAccessFunction',
          icon: 'numerical',
          text: i18n.t('common.menu.targetDeliveryTemplatePerAccessFunction'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${TARGET_TEMPLATE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'], // TODO: Confirm with XMS team
        },
        {
          id: 'additionalSetting',
          text: i18n.t('common.menu.additionalSettings'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}/xms`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
          isTopMenu: true,
        },
        {
          id: 'networkId',
          icon: 'numerical',
          text: i18n.t('common.menu.networkId'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NETWORK_ID_ROUTE}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'radiusParserPassword',
          icon: 'numerical',
          text: i18n.t('common.menu.radiusParserPassword'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'xtp',
          icon: 'numerical',
          text: i18n.t('common.menu.xtp'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'targetDeliveryTemplatePerAccessFunction',
          icon: 'numerical',
          text: i18n.t('common.menu.targetDeliveryTemplatePerAccessFunction'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${TARGET_DELIVERY_TEMPLATE_PER_ACCESS_FUNCTION}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'], // TODO: Confirm with XMS team
        },
        {
          id: 'xdp',
          icon: 'numerical',
          text: i18n.t('common.menu.xdp'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XDP}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'], // TODO: Confirm with XMS team
        },
        {
          id: 'xtpXdpConnection',
          icon: 'numerical',
          text: i18n.t('common.menu.xtpXdpConnection'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP_XDP_CONNECTION}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'fqdn',
          icon: 'numerical',
          text: i18n.t('common.menu.fqdn'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        },
        {
          id: 'targetDomain',
          icon: 'numerical',
          text: i18n.t('common.menu.targetDomain'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${TARGET_DOMAIN}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'], // TODO: Confirm with XMS team
        },
        {
          id: 'snmpDestination',
          icon: 'numerical',
          text: i18n.t('common.menu.snmpDestinations'),
          route: `${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${SNMP_DEST}`,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          permissions: ['dc_access'],
        }
      ],
    },
  ];

  if (isSecurityGatewayEnabled) {
    const systemSettingItem: NavbarItem | undefined = navbar.find(
      (item: NavbarItem) => item.id === 'systemConfiguration',
    );
    systemSettingItem?.children?.splice(1, 0, {
      id: 'securityGateway',
      icon: 'shield',
      text: i18n.t('common.menu.securityGateway'),
      route: `${SYSTEM_CONFIGURATION_ROUTE}${SECURITY_GATEWAY_ROUTE}`,
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      permissions: ['tp_access'],
    });
  }

  if (!_.isEmpty(openSearchUrl)) {
    navbar.splice(4, 0, {
      id: 'logs',
      icon: 'th-list',
      text: 'Logs',
      route: '/logs',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: false,
      permissions: ['log_monitoring_view'],
    });
  }

  if (isExternalDashboardEnabled) {
    if (!_.isEmpty(externalDashboardId)) {
      navbar.splice(4, 0, {
        id: 'external-dashboard',
        icon: 'chart',
        text: i18n.t('common.menu.dashboard'),
        route: externalDashboardRoute,
        className: 'bp3-intent-primary',
        inactiveClassName: 'bp3-minimal',
        defaultSelected: true,
        permissions: [
          'dashboard_af',
          'dashboard_cf',
          'dashboard_warrant',
          'dashboard_KPI',
          'dashboard_alarm',
          'dashboard_license',
          'dashboard_sh',
          'dashboard_admin',
        ],
      });
    }
    if (!isXmsMenusEnabled) {
      if (!_.isEmpty(systemHealthDashboardId)) {
        navbar.splice(5, 0, {
          id: 'external-system-health',
          icon: 'pulse',
          text: i18n.t('common.menu.systemHealth'),
          route: externalSystemHealthRoute,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          defaultSelected: true,
          permissions: [
            'dashboard_af',
            'dashboard_cf',
            'dashboard_warrant',
            'dashboard_KPI',
            'dashboard_alarm',
            'dashboard_license',
            'dashboard_sh',
            'dashboard_admin',
          ],
        });
      }
      if (!_.isEmpty(xcipioLicensesDashboardId) && !_.isEmpty(aggLicensesDashboardId)) {
        navbar.splice(6, 0, {
          id: 'external-monitoring',
          icon: 'dashboard',
          text: i18n.t('common.menu.monitoring'),
          route: externalXcipioLicensesRoute,
          className: 'bp3-intent-primary',
          inactiveClassName: 'bp3-minimal',
          defaultSelected: true,
          permissions: [
            'dashboard_af',
            'dashboard_cf',
            'dashboard_warrant',
            'dashboard_KPI',
            'dashboard_alarm',
            'dashboard_license',
            'dashboard_sh',
            'dashboard_admin',
          ],
          children: [
            {
              id: 'xcipio-licenses',
              icon: 'label',
              text: i18n.t('common.menu.xcipioLicenses'),
              route: externalXcipioLicensesRoute,
              className: 'bp3-intent-primary',
              inactiveClassName: 'bp3-minimal',
              permissions: [
                'dashboard_af',
                'dashboard_cf',
                'dashboard_warrant',
                'dashboard_KPI',
                'dashboard_alarm',
                'dashboard_license',
                'dashboard_sh',
                'dashboard_admin',
              ],
              isTopMenu: true,
            },
            {
              id: 'agg-licenses',
              icon: 'label',
              text: i18n.t('common.menu.aggregateLicenses'),
              route: externalAggLicensesRoute,
              className: 'bp3-intent-primary',
              inactiveClassName: 'bp3-minimal',
              permissions: [
                'dashboard_af',
                'dashboard_cf',
                'dashboard_warrant',
                'dashboard_KPI',
                'dashboard_alarm',
                'dashboard_license',
                'dashboard_sh',
                'dashboard_admin',
              ],
              isTopMenu: true,
            }
          ],
        });
      }
    }
  }

  if (isNetworkTopologyEnabled) {
    navbar.splice(4, 0, {
      id: 'topology',
      icon: 'layout',
      text: i18n.t('common.menu.networkTopology'),
      route: '/topology',
      className: 'bp3-intent-primary',
      inactiveClassName: 'bp3-minimal',
      defaultSelected: true,
      permissions: ['network_topology_view'],
    },);
  }

  if (isAlarmFeatureEnabled) {
    const alarmMenuItem: NavbarItem | undefined = {
      id: 'alarm',
      icon: IconAlarm(),
      text: i18n.t('common.menu.alarm'),
      route: '/activeAlarms',
      className: 'bp3-minimal',
      permissions: ['audit_log_view', 'audit_log_delete'],
      children: []
    }

    const childrenMenuItem: NavbarSubItem[] = [
      {
        id: 'activeAlarm',
        text: i18n.t('common.menu.activeAlarm'),
        route: '/activeAlarms',
        className: 'bp3-intent-primary',
        inactiveClassName: 'bp3-minimal',
        permissions: ['audit_log_view'],
        isTopMenu: true,
      },
      {
        id: 'suppressedAlarm',
        text: i18n.t('common.menu.suppressedAlarm'),
        route: '/suppressedAlarms',
        className: 'bp3-intent-primary',
        inactiveClassName: 'bp3-minimal',
        permissions: ['audit_log_view'],
        isTopMenu: true,
      },
      {
        id: 'historicalAlarm',
        text: i18n.t('common.menu.historicalAlarm'),
        route: '/historicalAlarms',
        className: 'bp3-intent-primary',
        inactiveClassName: 'bp3-minimal',
        permissions: ['audit_log_view'],
        isTopMenu: true,
      }
    ];
    if (isAlarmNotificationProfileEnabled) {
      childrenMenuItem.splice(3, 0, {
        id: 'configureAlarmNotification',
        text: i18n.t('common.menu.configureAlarmNotification'),
        route: '/systemConfiguration/system/alarm-notification-profile',
        className: 'bp3-intent-primary',
        inactiveClassName: 'bp3-minimal',
        permissions: ['audit_log_view'],
        isTopMenu: true,
      })
    }
    alarmMenuItem.children = childrenMenuItem;
    navbar.splice(9, 0, alarmMenuItem)
  }

  if (!isEWarrantEnabled) {
    const eWarrantIndex = navbar.findIndex((item: NavbarItem) => item.id === 'eWarrants');
    if (eWarrantIndex > -1) {
      navbar.splice(eWarrantIndex, 1);
    }
  }

  // Tenant needs the 'multitenant' supported feature, on top of the csp_admin permission.
  if (!isMultitenantEnabled) {
    const peopleItem: NavbarItem | undefined = navbar.find((item: NavbarItem) => item.id === 'people');
    const tenantIndex = peopleItem?.children?.findIndex(({ id }) => id === 'tenant') ?? -1;
    if (tenantIndex > -1) {
      peopleItem?.children?.splice(tenantIndex, 1);
    }
  }

  if (isXmsMenusEnabled === false) {
    const systemSettingItem: NavbarItem | undefined = navbar.find(
      (item: NavbarItem) => item.id === 'systemConfiguration',
    );
    const additinalSettingsIndex = systemSettingItem?.children?.findIndex(({ id }) => id === 'additionalSetting');
    if (additinalSettingsIndex) {
      systemSettingItem?.children?.splice(additinalSettingsIndex, 1);
    }

    const afItem: NavbarItem | undefined = navbar.find(
      (item: NavbarItem) => item.id === 'accessFunction',
    );
    afItem?.children?.splice(1, 1);
    return navbar.filter((item: NavbarItem) => !item.id.startsWith('xms_'));
  }

  return navbar;
}
